const FIRST_LOGIN_MISSION_ID = 1
const MISSION_RECEIVED_STATUS = 3

export function shouldRefreshAccountAfterMissionQuery (missions, leftExpTime = 0) {
    if (!Array.isArray(missions)) return false

    const firstLoginMission = missions.find((mission) => {
        return mission && mission.mission_id === FIRST_LOGIN_MISSION_ID
    })
    if (!firstLoginMission || firstLoginMission.status !== MISSION_RECEIVED_STATUS) {
        return false
    }

    const rewardAmount = Number(firstLoginMission.amount) || 0
    return rewardAmount > 0 && Number(leftExpTime || 0) < rewardAmount
}
